module.exports = __webpack_public_path__ + "static/responsive-web-2-db2fce10422ed78dc25d56795fdeec56.png";